module.exports = __webpack_public_path__ + "static/media/splatMath.fe8f70af.png";